export enum Positions {
  top = 'top',
  bottom = 'bottom',
  left = 'left',
  right = 'right',
  topLeft = 'top-left',
  topRight = 'top-right',
  bottomLeft = 'bottom-left',
  bottomRight = 'bottom-right',
}

type CardinalPosition =
  | Positions.top
  | Positions.bottom
  | Positions.left
  | Positions.right;

const opposite = {
  [Positions.top]: Positions.bottom,
  [Positions.bottom]: Positions.top,
  [Positions.left]: Positions.right,
  [Positions.right]: Positions.left,
};

export function flipPosition(
  startingPosition: Positions,
  targetSide: CardinalPosition,
): Positions {
  const newPosition = startingPosition.replace(
    opposite[targetSide],
    targetSide,
  ) as Positions;

  // If new side isn't in the result (wasn't flipped), add it
  // Can assume new position is cardinal or it would contain `side` at this point
  if (!newPosition.includes(targetSide)) {
    return combineSides(targetSide, newPosition as CardinalPosition);
  }

  return newPosition;
}

export function combineSides(sideA: CardinalPosition, sideB: CardinalPosition) {
  if (sideA === sideB || opposite[sideA] === sideB) {
    return sideA;
  }

  return sideA === Positions.top || sideA === Positions.bottom
    ? (`${sideA}-${sideB}` as Positions)
    : (`${sideB}-${sideA}` as Positions);
}
